import { ActionType, ProColumns } from '@ant-design/pro-components'
import { Form, Input } from 'antd'
import BoxContainer from 'base/ui/components/BoxContainer'
import { SearchForm, SearchItem } from 'pages/Components/SearchBox'
import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import CustomButton from 'base/ui/components/Button';
import CustomProTable, { tablePagination } from 'base/ui/components/CustomTable'
import CustomSelect from 'base/ui/components/CustomSelect'
import { customerGeneralReportPresenter, customerGeneralReportStore } from 'stores/root_store'
import { cloneDeep } from 'lodash'
import { getSaleOrgCode } from 'utils/localStorageHelper'
import { SearchModel } from 'pages/model'
import { PAGE_SIZE_DEFAULT } from 'utils/constants'
import { CustomerModel } from 'services/Main/customerGeneralReport_services'
import { CheckStatus, CloseStatus } from 'base/ui/components/Icons'

type Props = {
  handleSelectCustomer: (customer: string, customerCode: string) => void
}

const status = [
  {
    value: true,
    label: 'Đang sử dụng',
  },
  {
    value: false,
    label: 'Ngưng sử dụng',
  },
];

const ModalCustomer = ({ handleSelectCustomer }: Props) => {



  //=====================================CHUYỂN NGÔN NGỮ=================================================//
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const tableRef = useRef<ActionType>();
  const [loading, setLoading] = useState(false)

  const [listCustomer, setListCustomer] = useState<CustomerModel[]>([])



  //--- DATA TABLE ------------------------------------------------------------
  const [dataPaging, setDataPaging] = useState<SearchModel>({
    paging: {
      pageSize: PAGE_SIZE_DEFAULT,
      pageIndex: 1,
      orderBy: undefined,
      orderByDesc: undefined,
    },
    currentCompanyCode: getSaleOrgCode()
  });

  const defaultColumn: ProColumns[] = [
    {

      title: 'STT',
      dataIndex: 'stt',
      width: 50,
      align: 'center',
    },
    // Mã
    {
      title: 'Mã',
      dataIndex: 'profileCode',
      align: 'center',
    },
    // Mã SAP
    {
      title: 'Mã SAP',
      dataIndex: 'profileForeignCode',
      align: 'center',
    },
    // Tên
    {
      title: 'Tên',
      dataIndex: 'profileName',
      align: 'center',
    },
    // Phân loại KH
    {
      title: 'Phân loại KH',
      dataIndex: 'customerTypeName',
      align: 'center',
    },
    // SĐT liên hệ
    {
      title: 'SĐT liên hệ',
      dataIndex: 'profilePhone',
      align: 'center',
    },
    // Email
    {
      title: 'Email',
      dataIndex: 'email',
      align: 'center',
    },
    // Trạng thái
    {
      title: 'Trạng thái',
      dataIndex: 'actived',
      align: 'center',
      render: (_, record) =>
        record.actived ? (
          <CheckStatus width="14" className="!fill-[#0052cc] block mx-auto" />
        ) : (
          <CloseStatus width="14" className="!fill-red-500 block mx-auto" />
        ),
    },

    // Chức năng
    {
      title: 'Chọn',
      dataIndex: 'chon',
      align: 'center',
      render: (value, record) => {
        return <div className='flex items-center justify-center'>
          <CustomButton onClick={() => {
            setLoading(true)
            setTimeout(() => {
              handleSelectCustomer(record.profileName, record.profileId)
              setLoading(false)
            }, 500);
          }} size='small'>Chọn</CustomButton>
        </div>
      }
    },
  ]


  const handleGetDataCustomer = async (dataSearch: object) => {
    await customerGeneralReportPresenter.getListCustomer(customerGeneralReportStore, dataSearch);
    if (customerGeneralReportStore.listCustomer.isSuccess) {
      const dataTemp = cloneDeep(customerGeneralReportStore.listCustomer.data);
      setListCustomer(dataTemp);
      return dataTemp;
    }
    setListCustomer([]);
    return [];
  }




  return (
    <BoxContainer>
      <SearchForm
        form={form} column="col-2"
        onFinish={(value) => {
          setLoading(true)
          setDataPaging({
            paging: {
              pageSize: PAGE_SIZE_DEFAULT,
              pageIndex: 1,
            },
            currentCompanyCode: getSaleOrgCode(),
            ...Object.fromEntries(Object.entries(value).filter(([_, e]) => {
              if (typeof e === 'boolean') {
                return true
              } else if (Array.isArray(e) && e.length === 0) {
                return false
              }
              else {
                return !!e
              }
            })),
          })
          tableRef.current?.reload()
          setLoading(false)
        }}
      >
        {/* Mã */}
        <SearchItem label={'Mã'} name={'profileCode'}>
          <Input />
        </SearchItem>
        {/* Mã SAP */}
        <SearchItem label={'Mã SAP'} name={'profileForeignCode'}>
          <Input />
        </SearchItem>
        {/* Tên */}
        <SearchItem label={'Tên'} name={'profileName'}>
          <Input />
        </SearchItem>
        {/* SĐT liên hệ */}
        <SearchItem label={'SĐT liên hệ'} name={'phone'}>
          <Input />
        </SearchItem>
        {/* Phân loại KH */}
        <SearchItem label={'Phân loại KH'} name={'customerTypeCode'}>
          <Input />
        </SearchItem>
        {/* Trạng thái */}
        <SearchItem label={'Trạng thái'} name={'actived'}>
          <CustomSelect
            options={status}
            allowClear
          />
        </SearchItem>

        <div className='col-span-2 mt-5 flex justify-center items-center'>
          <CustomButton loading={loading} type='primary' onClick={() => {
            form.submit()
          }}>
            Tìm kiếm
          </CustomButton>
        </div>
      </SearchForm>


      <CustomProTable
        columns={defaultColumn}
        rowKey="stt"
        size="small"
        dataSource={listCustomer}
        search={false}
        loading={loading}
        actionRef={tableRef}
        scroll={{ y: 250 }}
        request={async (params = {}, sort, filter) => {
          setLoading(true)
          const data = await handleGetDataCustomer({
            ...dataPaging,
          });
          setLoading(false)
          return {
            data: data,
            success: customerGeneralReportStore.listCustomer.isSuccess,
          };
        }}

        pagination={{
          ...tablePagination(dataPaging, setDataPaging),
          total: customerGeneralReportStore.listCustomer.paging?.totalCount,
        }}

        options={false}
      />
    </BoxContainer>
  )
}

export default ModalCustomer